import { render } from "./HubPage.vue?vue&type=template&id=c7939742"
import script from "./HubPage.vue?vue&type=script&lang=js"
export * from "./HubPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__